"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.todos.completed': 'Completada',
    'tutorial.todos.pending': 'Pendiente',
    'tutorial.todos.markCompleted': 'Marcar como completada',
    'tutorial.todos.markPending': 'Marcar como pendiente',
    'tutorial.todos.statusDone': 'hecha',
    'tutorial.todos.statusUndone': 'no hecha',
    'tutorial.todos.changeComment.1': 'Has cambiado el estado de la tarea "{name}" a: {status}.',
    'tutorial.todos.changeComment.2': 'Tarea "{name}" – {status}. Anotado.',
    'tutorial.todos.changeComment.3': 'He registrado el cambio: la tarea "{name}" ahora está {status}.',
    'tutorial.todos.changeComment.4': '¡Guardado! La tarea "{name}" está marcada como {status}.',
    'tutorial.audio.stop': 'Detener',
    'tutorial.audio.pause': 'Pausa',
    'tutorial.audio.play': 'Reproducir',
    'tutorial.audio.volume': 'Volumen',
    'tutorial.audio.writingSpeed': 'Velocidad de escritura',
    'tutorial.audio.writingSpeed.normal': 'Normal',
    'tutorial.audio.writingSpeed.fast': 'Rápida',
    'tutorial.audio.writingSpeed.veryFast': 'Muy rápida',
};
